import React, { Component } from 'react'

export default class Logout extends Component {
  handleClick = (event) => {
    event.preventDefault()
    this.props.logout()
  }

  render() {
    return (
      <a className="logout" href="#" onClick={this.handleClick}>Log Out</a>
    )
  }
}



// WEBPACK FOOTER //
// client/components/auth/Logout.js